module.exports = __webpack_public_path__ + "7e611891a8746adb71c7e1cce25e8812.fbx";